import produce from "immer";
import { Product } from "../../interfaces/products";
import createReducer from "./reducerUtils";

const initialState = {
  currProduct: [] as Product[],
};
const productReducer = {
  setCurrProduct(state: any, action: any) {
    state.currProduct = action.payload;
  },
};

export default produce(
  (state = initialState, action) =>
    createReducer(state, action, productReducer),
  initialState
);
